type HeritageOrnamentProps = {
  className?: string;
};

export function HeritageOrnament({ className }: HeritageOrnamentProps) {
  return (
    <svg className={className} viewBox="0 0 282 44" aria-hidden="true" focusable="false">
      <path d="M14 22h82" />
      <path d="M186 22h82" />
      <path d="M99 22c13-19 31-19 42 0 11-19 29-19 42 0-13 19-31 19-42 0-11 19-29 19-42 0Z" />
      <path d="M113 22c9-9 18-9 28 0 9-9 18-9 28 0" />
      <circle cx="14" cy="22" r="5" />
      <circle cx="268" cy="22" r="5" />
      <circle cx="141" cy="22" r="4" />
    </svg>
  );
}
